export class  Board {
  uid: string;
  id: string;
  title: string;
  public: boolean;
  memberPosts: boolean;
  commentsEnabled: boolean;
  isHome: boolean;
  organization: string;
  creatorName: string[] = [];
  creationDate: string;
  createdBy: string;
  coverPhoto?: string;
  managers?: any;
  order?: number;
  members?: {
    [memberId: string] : true;
  }
    
  constructor (init: Partial<Board>){
      Object.assign(this, init);
  }

  public isManager(userId: string): boolean {
    return this.managers && this.managers[userId]
  } 

  public isMember(userId: string): boolean {
    return this.members && this.members[userId]
  } 
}